import {http} from '@/helpers/http-helper';

export const getDistributions = () => {
  return new Promise( (resolve, reject) => {
    const url = 'distribution-lists';
    http.get(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteDistributionList = (distributionListId) => {
  return new Promise( (resolve, reject) => {
    const url = 'distribution-list/' + distributionListId;
    http.delete(url)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        else {
          reject(response.status);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
